import SyncIcon from '@mui/icons-material/Sync';
import { FC, memo } from 'react';
import { AutoFollowUpStatus } from '../../../../../../../services/api-client/contact-api.types';
import { FollowUpStatusChip } from './auto-followup-status.styles';

export interface AutoFollowUpStatusComponentProps {
  autoFollowUpStatus: AutoFollowUpStatus;
}

export const AutoFollowUpStatusComponent: FC<AutoFollowUpStatusComponentProps> = memo((props) => {
  const { autoFollowUpStatus } = props;

  switch (autoFollowUpStatus) {
    case 'On':
      return (
        <FollowUpStatusChip className="follow-up-status-chip" sx={{ backgroundColor: 'rgba(0, 138, 6, 1)' }}>
          <SyncIcon sx={{ marginRight: '4px', fontSize: '16px' }} />
          Follow Up
        </FollowUpStatusChip>
      );
    case 'Off':
      return <FollowUpStatusChip className="follow-up-status-chip">No Follow Up</FollowUpStatusChip>;
    case 'Disabled':
      return <FollowUpStatusChip className="follow-up-status-chip">Campaign Off</FollowUpStatusChip>;
    case 'OutOfRange':
      return (
        <FollowUpStatusChip className="follow-up-status-chip" sx={{ backgroundColor: 'rgba(218, 166, 32, 1)' }}>
          Out of Range
        </FollowUpStatusChip>
      );
    default:
      return null;
  }
});
